module.exports = __webpack_public_path__ + "img/aa.014f9cc1.png";